<script setup lang="ts" generic="TData">
import type { MyWalletGateState } from '~/features/my-wallet/types/screen-state'
import MyWalletEmpty from '~/features/my-wallet/components/MyWalletEmpty.vue'
import MyWalletError from '~/features/my-wallet/components/MyWalletError.vue'

interface Props {
  state: MyWalletGateState
  data: TData | null
  errorId: string
  headingTag?: 'h3' | 'h4'
}

withDefaults(defineProps<Props>(), {
  headingTag: 'h3',
})

const emit = defineEmits<{
  retry: []
}>()

defineSlots<{
  skeleton: () => unknown
  default: (slotProps: { data: TData }) => unknown
}>()
</script>

<template>
  <MyWalletError
    v-if="state === 'error' || state === 'forbidden'"
    :id="errorId"
    :forbidden="state === 'forbidden'"
    :heading-tag="headingTag"
    @retry="emit('retry')"
  />

  <slot v-else-if="state === 'loading'" name="skeleton" />

  <MyWalletEmpty v-else-if="state === 'empty' || data === null" :heading-tag="headingTag" />

  <slot v-else :data="data" />
</template>
